const CursorActionTypes = {
  UPDATE_CURSOR_TYPE: "UPDATE_CURSOR_TYPE",
};

export default CursorActionTypes;
